/* Deckaura Daily Tarot Card — Enterprise V7 */
(function () {
  'use strict';

  var FALLBACK_PRICES = { deeper: '$9.99', indepth: '$16.99' };
  var PACKAGE_NAMES = {
    deeper: "Today's Turning Point",
    indepth: 'Your 7-Day Tarot Roadmap'
  };
  var PACKAGE_SCOPE = {
    deeper: { horizon: 'today_plus_48_hours', cards: 3, promise: "Today's card plus two clarifying cards and a 48-hour mini plan" },
    indepth: { horizon: 'next_7_days', cards: 7, promise: 'Seven-card direction map with a three-step plan' }
  };
  /* Backend (lib/daily-tarot.ts) odak anahtarlari; tema anahtarlari UI icin kalir (2026-09-03 intent fix). */
  var DAILY_INTENT_FOCUS = { love: 'love_relationships', work: 'work_money', decision: 'decision', wellbeing: 'emotional_wellbeing', general: 'general_direction' };
  var DAILY_CATEGORY = { love: 'love', work: 'career', decision: 'personal', wellbeing: 'personal', general: 'general' };
  var FOCUS = {
    love: {
      label: 'Love & relationships',
      question: "How can I apply today's card to the relationship situation on my mind?",
      notice: 'Look for consistency, reciprocity and visible boundaries rather than guessed intentions.',
      action: 'Choose one respectful action that does not depend on another person’s hidden feelings.'
    },
    work: {
      label: 'Work & money',
      question: "How can I apply today's card to the work or money situation on my mind?",
      notice: 'Separate evidence, timing and practical cost before choosing a direction.',
      action: 'Take one reversible step that improves clarity, fair exchange or practical stability.'
    },
    decision: {
      label: 'A decision',
      question: "What does today's card invite me to notice about the decision in front of me?",
      notice: 'Name the fact that would genuinely change your choice, then look for it.',
      action: 'Make the smallest testable move and decide what evidence you will review afterward.'
    },
    wellbeing: {
      label: 'Emotional wellbeing',
      question: "How can I use today's card as a grounded reflection on my emotional wellbeing?",
      notice: 'Notice what restores steadiness without asking you to ignore your real limits.',
      action: 'Protect one boundary or routine that helps you respond instead of react.'
    },
    general: {
      label: 'General direction',
      question: "What is the most useful way to work with today's card?",
      notice: 'Watch for the option that becomes clearer through observable movement, not urgency.',
      action: 'Choose one useful action you can complete today and reassess with new information.'
    }
  };
  var SUIT_ACTION = {
    major: 'Name the larger theme, then choose one action small enough to test today.',
    wands: 'Direct the available energy into one deliberate action before adding another commitment.',
    cups: 'Acknowledge the feeling, then ask what respectful action it actually supports.',
    swords: 'Separate the verified fact from the strongest assumption before you decide.',
    pentacles: 'Choose the most practical step that improves stability, resources or follow-through.'
  };

  function query(scope, selector) { return scope.querySelector(selector); }
  function queryAll(scope, selector) { return Array.prototype.slice.call(scope.querySelectorAll(selector)); }
  function pad(value) { return String(value).padStart(2, '0'); }
  function dateKey(date) { return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate()); }
  function hash(value) {
    var h = 2166136261;
    for (var i = 0; i < value.length; i += 1) {
      h ^= value.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }
  function dailyDateHash(value) {
    var valueHash = 0;
    for (var i = 0; i < value.length; i += 1) {
      valueHash = ((valueHash << 5) - valueHash) + value.charCodeAt(i);
      valueHash &= valueHash;
    }
    return Math.abs(valueHash);
  }
  function dailySeededRandom(seed) {
    var value = Math.sin(seed) * 10000;
    return value - Math.floor(value);
  }
  function titleCase(value) {
    return String(value || '').replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }
  function appendWidth(source, width) {
    if (!source) return '';
    return source + (source.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }
  function track(name, props) {
    try {
      var audit = new URLSearchParams(window.location.search || '');
      if (audit.has('codex_audit') || audit.has('deckaura_internal') || audit.has('alltools_audit') || audit.has('funnel_audit') || audit.get('internal') === 'true' || audit.get('traffic_type') === 'internal') return;
      if (window.clarity) {
        window.clarity('event', name);
        Object.keys(props || {}).forEach(function (key) { window.clarity('set', key, String(props[key])); });
      }
    } catch (_) {}
  }

  function decodeTranslationText(value) {
    var named = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: '\u00a0' };
    return String(value).replace(/&(#(?:x[0-9a-f]+|[0-9]+)|amp|lt|gt|quot|apos|nbsp);/gi, function (entity, code) {
      if (code.charAt(0) !== '#') return named[code.toLowerCase()];
      var hexadecimal = code.charAt(1).toLowerCase() === 'x';
      var point = parseInt(code.slice(hexadecimal ? 2 : 1), hexadecimal ? 16 : 10);
      if (!Number.isInteger(point) || point < 0x20 || point > 0x10ffff || (point >= 0x7f && point <= 0x9f) || (point >= 0xd800 && point <= 0xdfff)) return entity;
      return String.fromCodePoint(point);
    });
  }

  function boot(root) {
    if (root.getAttribute('data-dt49-booted') === 'true') return;
    root.setAttribute('data-dt49-booted', 'true');
    var words = {};
    try {
      var dictionary = JSON.parse(query(root, '[data-dt49-i18n]').textContent);
      Object.keys(dictionary).forEach(function (name) {
        if (typeof dictionary[name] === 'string') words[name] = decodeTranslationText(dictionary[name]);
      });
    } catch (_) {}
    function t(name, params) {
      var value = String(words[name] || '');
      return value.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) { return params && params[key] != null ? String(params[key]) : ''; });
    }
    var locale = root.getAttribute('data-dt49-locale') || document.documentElement.lang || 'en';
    var language = locale.toLowerCase().split('-')[0];
    var localizedSets = window.DT49_LOCALIZED_CARDS || {};
    var displayLocale = Object.keys(localizedSets).filter(function (key) { return key.toLowerCase() === locale.toLowerCase(); })[0];
    var localizedCards = localizedSets[displayLocale] || localizedSets[language] || (language === 'pt' ? localizedSets['pt-PT'] : null) || localizedSets.en || [];
    var cards = Array.isArray(window.DT49_CARDS) ? window.DT49_CARDS : [];
    if (cards.length !== 78) return;
    /* Preserve the established live date-to-card sequence while using the
       prototype's stronger editorial data and canonical art order. */
    var liveOrder = cards.slice(0, 22)
      .concat(cards.slice(36, 50))
      .concat(cards.slice(64, 78))
      .concat(cards.slice(50, 64))
      .concat(cards.slice(22, 36));

    var artMap = {};
    try {
      var artNode = document.getElementById('dailyTarotCardArtMapV2');
      artMap = artNode ? JSON.parse(artNode.textContent || '{}') : {};
    } catch (_) { artMap = {}; }

    var selectedDate = new Date();
    var params = new URLSearchParams(window.location.search);
    var isYesterday = params.get('date') === 'yesterday';
    if (isYesterday) selectedDate.setDate(selectedDate.getDate() - 1);
    selectedDate.setHours(12, 0, 0, 0);

    var key = dateKey(selectedDate);
    var seedKey = selectedDate.getFullYear() + '-' + (selectedDate.getMonth() + 1) + '-' + selectedDate.getDate();
    var seed = dailyDateHash(seedKey);
    var liveIndex = Math.floor(dailySeededRandom(seed) * liveOrder.length);
    var card = liveOrder[liveIndex];
    var cardIndex = cards.indexOf(card);
    var displayCard = localizedCards[cardIndex] || { name: card[0], meaning: card[2], upright: card[3], reversed: card[4] };
    var reversed = dailySeededRandom(seed + 1) < .3;
    var orientation = reversed ? 'Reversed' : 'Upright';
    var selectedFocus = 'general';
    var selectedTier = 'deeper';
    var checkoutBusy = false;
    var checkoutFailed = false;
    var lastCheckoutButton = null;
    var checkoutTimer = 0;
    var contextTimer = 0;
    var readingTimer = 0;
    var contextGeneration = 0;
    var configuredGeneration = -1;
    var checkoutAttempt = 0;
    var reviewPending = false;
    var reviewReason = '';
    var beforeReviewStatuses = [];
    var returnStatuses = null;
    var readingReady = false;
    var hasSeenOffer = false;
    var expired = false;
    var lastPricingSnapshot = { status: 'idle', tiers: [] };
    var storageKey = 'deckaura.dailyTarot.v7';
    var productReady = root.getAttribute('data-dt49-product-ready') === 'true';
    var localizedOrientation = t(reversed ? 'reversed' : 'upright');
    var fallbackPrices = {
      deeper: root.getAttribute('data-dt49-price-deeper') || FALLBACK_PRICES.deeper,
      indepth: root.getAttribute('data-dt49-price-indepth') || FALLBACK_PRICES.indepth
    };

    var dateLong = query(root, '[data-dt49-date-long]');
    var dateShort = query(root, '[data-dt49-date-short]');
    var countdown = query(root, '[data-dt49-countdown]');
    var revealButtons = queryAll(root, '[data-dt49-reveal],[data-dt49-reveal-card]');
    var cardImage = query(root, '[data-dt49-card-image]');
    var title = query(root, '[data-dt49-title]');
    var resultTitle = query(root, '[data-dt49-result-title]');
    var lead = query(root, '[data-dt49-lead]');
    var result = query(root, '[data-dt49-result]');
    var resultKicker = query(root, '[data-dt49-result-kicker]');
    var revealButton = query(root, '[data-dt49-reveal]');
    var freeNote = query(root, '[data-dt49-free-note]');
    var offers = query(root, '[data-dt49-offers]');
    var archive = query(root, '[data-dt49-archive]');
    var focusSelect = query(root, '[data-dt49-focus-select]');
    var situation = query(root, '[data-dt49-situation]');
    var priceStatus = query(root, '[data-dt49-price-status]');
    var priceRetry = query(root, '[data-dt49-price-retry]');
    var checkoutSupport = query(root, '[data-dt49-checkout-support]');
    var checkoutButtons = queryAll(root, '[data-dt49-checkout]');
    var mobileCheckout = query(root, '[data-dt49-mobile-checkout]');
    var stickyButton = query(root, '[data-dt49-sticky-checkout]');
    var tierButtons = queryAll(root, '[data-dt49-tier]');
    var tierPanels = queryAll(root, '[data-dt49-panel]');
    var toast = query(root, '[data-dt49-toast]');
    var cartReview = query(root, '[data-dt49-cart-review]');

    var displayDate = selectedDate.toLocaleDateString(locale, { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
    if (dateLong) dateLong.textContent = displayDate;
    if (dateShort) dateShort.textContent = selectedDate.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
    if (isYesterday) {
      root.classList.add('is-archive');
      if (title) title.textContent = t('yesterday_heading');
      if (lead) lead.textContent = t('yesterday_lead');
      if (revealButton) revealButton.textContent = t('yesterday_reveal');
      revealButtons.forEach(function (button) { button.setAttribute('aria-label', t('yesterday_reveal')); });
      var dayLabel = query(root, '[data-dt49-day-label]');
      if (dayLabel) dayLabel.textContent = t('yesterday_day');
      var energyLabel = query(root, '[data-dt49-energy-label]');
      if (energyLabel) energyLabel.textContent = t('yesterday_energy');
      var countdownLabel = query(root, '[data-dt49-countdown-label]');
      if (countdownLabel) countdownLabel.hidden = true;
      var tomorrow = query(root, '[data-dt49-tomorrow]');
      if (tomorrow) tomorrow.hidden = true;
      var yesterdayLink = query(root, '[data-dt49-yesterday]');
      if (yesterdayLink) { yesterdayLink.href = window.location.pathname; yesterdayLink.textContent = t('back_today'); }
      var todayLink = query(root, '[data-dt49-today-link]');
      if (todayLink) todayLink.href = window.location.pathname;
    }

    function showToast(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(showToast.timer);
      showToast.timer = window.setTimeout(function () { toast.classList.remove('is-visible'); }, 3400);
    }
    function hasVerifiedPrice(tier) {
      var quote = (lastPricingSnapshot.tiers || []).filter(function (item) { return item.tier === tier; })[0];
      return lastPricingSnapshot.status === 'ready' && Boolean(quote && quote.available && Number.isInteger(quote.price_minor) && quote.price_minor > 0 && quote.formatted_price) && /^[A-Z]{3}$/.test(String(lastPricingSnapshot.currency || ''));
    }
    function isCurrentPaidDate() {
      var now = new Date();
      var utcDay = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
      var selectedDay = Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());
      return !isYesterday && !expired && key === dateKey(now) && Math.abs(selectedDay - utcDay) <= 86400000;
    }
    function clearCartReview() {
      reviewPending = false;
      reviewReason = '';
      beforeReviewStatuses = [];
      returnStatuses = null;
      if (cartReview) {
        cartReview.__deckauraRecoveryGeneration = (cartReview.__deckauraRecoveryGeneration || 0) + 1;
        cartReview.textContent = '';
        cartReview.hidden = true;
      }
    }
    function sharedStatuses() {
      return queryAll(root, '#ddrGateNote,#ddrNote').map(function (node) { return { node: node, text: node.textContent }; });
    }
    function recoverableCartReason(reason) {
      return /^(reading_cart_conflict|cart_changed|cart_operation_busy|cart_result_uncertain|cart_read_failed|cart_add_failed|checkout_guard_unavailable|checkout_navigation_busy)$/.test(String(reason || ''));
    }
    function dismissReturnHint() {
      try { if (window.DeckauraCheckout && typeof window.DeckauraCheckout.dismissRecovery === 'function') window.DeckauraCheckout.dismissRecovery(); } catch (_) {}
    }
    function invalidateContext() {
      contextGeneration += 1;
      window.clearTimeout(contextTimer);
      window.clearTimeout(readingTimer);
      readingTimer = 0;
      clearCartReview();
      checkoutFailed = false;
      if (readingReady) {
        try { if (window.DeckauraDeepReading && window.DeckauraDeepReading.update) window.DeckauraDeepReading.update({ resultReady: false, checkoutRecoveryHost: cartReview }); } catch (_) {}
      }
      configuredGeneration = -1;
      setCheckoutBusy(false);
    }
    function cartReviewReady(generation, host) {
      if (generation !== contextGeneration || configuredGeneration !== generation || !isCurrentPaidDate() || host !== cartReview || !host || !host.isConnected) return;
      if (reviewReason === 'reading_cart_conflict') {
        returnStatuses = beforeReviewStatuses.filter(function (entry) { return entry.node.isConnected && entry.node.textContent && entry.node.textContent !== entry.text; }).map(function (entry) { return { node: entry.node, text: entry.node.textContent }; });
      }
      reviewPending = false;
      checkoutFailed = false;
      window.clearTimeout(checkoutTimer);
      setPrices(lastPricingSnapshot);
      dismissReturnHint();
      try { host.focus({ preventScroll: true }); safeScroll(host, 'start'); } catch (_) {}
    }
    function setCheckoutBusy(locked, activeButton) {
      checkoutBusy = Boolean(locked);
      activeButton = activeButton || lastCheckoutButton;
      checkoutButtons.forEach(function (button) {
        var tier = button.getAttribute('data-dt49-checkout') || '';
        var priceReady = Boolean(window.DeckauraDeepReading && window.DeckauraDeepReading.isPriceReady && window.DeckauraDeepReading.isPriceReady());
        var canCheckout = root.classList.contains('is-revealed') && isCurrentPaidDate() && productReady && priceReady && configuredGeneration === contextGeneration && !checkoutBusy && !reviewPending && (!cartReview || cartReview.hidden) && hasVerifiedPrice(tier);
        button.disabled = !canCheckout;
        if (checkoutBusy && button === activeButton) button.setAttribute('aria-busy', 'true');
        else button.removeAttribute('aria-busy');
      });
      tierButtons.forEach(function (button) { button.disabled = checkoutBusy; });
      if (focusSelect) focusSelect.disabled = checkoutBusy;
      if (situation) situation.readOnly = checkoutBusy;
      if (stickyButton) {
        stickyButton.disabled = !checkoutButtons[0] || checkoutButtons[0].disabled;
        if (checkoutBusy && activeButton === stickyButton) stickyButton.setAttribute('aria-busy', 'true');
        else stickyButton.removeAttribute('aria-busy');
      }
      updateSticky();
    }
    function setPrices(snapshot) {
      lastPricingSnapshot = snapshot && typeof snapshot === 'object' ? snapshot : { status: 'idle', tiers: [] };
      var tiers = snapshot && Array.isArray(snapshot.tiers) ? snapshot.tiers : [];
      var ready = hasVerifiedPrice(selectedTier) && Boolean(window.DeckauraDeepReading && window.DeckauraDeepReading.isPriceReady && window.DeckauraDeepReading.isPriceReady());
      var unavailable = snapshot && (snapshot.status === 'error' || snapshot.status === 'fallback_ready' || snapshot.status === 'ready' && !hasVerifiedPrice(selectedTier));
      Object.keys(FALLBACK_PRICES).forEach(function (tier) {
        var quote = tiers.filter(function (item) { return item.tier === tier; })[0];
        var formatted = quote && quote.formatted_price ? quote.formatted_price : fallbackPrices[tier];
        var currency = String(snapshot && snapshot.currency || root.getAttribute('data-dt49-currency') || '').toUpperCase();
        if (currency && String(formatted).toUpperCase().indexOf(currency) === -1) formatted += ' ' + currency;
        queryAll(root, '[data-dt49-price="' + tier + '"],[data-dt49-button-price="' + tier + '"]').forEach(function (node) { node.textContent = formatted; });
      });
      syncTierUi();
      var confirmedCurrency = String(snapshot && snapshot.currency || root.getAttribute('data-dt49-currency') || '').toUpperCase();
      if (priceStatus && !checkoutBusy) {
        if (expired) priceStatus.textContent = t('date_expired');
        else if (!root.classList.contains('is-revealed')) priceStatus.textContent = t('price_reveal');
        else if (!productReady) priceStatus.textContent = t('price_unavailable');
        else if (checkoutFailed) priceStatus.textContent = t('checkout_error');
        else if (ready) priceStatus.textContent = t('price_ready', { currency: confirmedCurrency });
        else if (unavailable) priceStatus.textContent = t('price_error');
        else priceStatus.textContent = t('price_loading');
      }
      if (priceRetry) {
        priceRetry.textContent = t(expired ? 'refresh_today' : checkoutFailed ? 'checkout_retry' : 'price_retry');
        priceRetry.hidden = checkoutBusy || isYesterday || !(root.classList.contains('is-revealed') && (expired || checkoutFailed || unavailable));
      }
      if (checkoutSupport) checkoutSupport.hidden = !checkoutFailed;
      setCheckoutBusy(checkoutBusy);
    }
    function currentFocus() {
      var focus = {};
      ['label', 'question', 'notice', 'action'].forEach(function (field) { focus[field] = t('focus_' + selectedFocus + '_' + field); });
      return focus;
    }
    function safeScroll(node, block) {
      if (node) node.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: block || 'nearest' });
    }
    function syncTierUi() {
      tierButtons.forEach(function (button) {
        var selected = button.getAttribute('data-dt49-tier') === selectedTier;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
      });
      tierPanels.forEach(function (panel) { panel.hidden = panel.getAttribute('data-dt49-panel') !== selectedTier; });
      checkoutButtons.forEach(function (button) { button.setAttribute('data-dt49-checkout', selectedTier); });
      var quote = (lastPricingSnapshot.tiers || []).filter(function (item) { return item.tier === selectedTier; })[0];
      var formatted = quote && quote.formatted_price || fallbackPrices[selectedTier];
      queryAll(root, '[data-dt49-selected-price],[data-dt49-sticky-price]').forEach(function (node) { node.textContent = formatted; });
      queryAll(root, '[data-dt49-selected-name],[data-dt49-sticky-name]').forEach(function (node) { node.textContent = t('package_' + selectedTier); });
      queryAll(root, '[data-dt49-checkout-label]').forEach(function (node) { node.textContent = t('checkout_button'); });
    }
    function chooseTier(tier, focusTab) {
      if (checkoutBusy || !/^(deeper|indepth)$/.test(tier)) return;
      if (tier !== selectedTier) invalidateContext();
      selectedTier = tier;
      syncTierUi();
      if (root.classList.contains('is-revealed')) waitForReading(0);
      saveState();
      if (focusTab) { var selected = query(root, '[data-dt49-tier="' + selectedTier + '"]'); if (selected) selected.focus(); }
    }
    function updateSticky() {
      if (!mobileCheckout) return;
      var active = document.activeElement;
      var typing = active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName);
      var viewport = window.visualViewport;
      var keyboard = viewport && viewport.height < window.innerHeight * .78;
      var main = checkoutButtons[0] && checkoutButtons[0].getBoundingClientRect();
      var mainVisible = main && main.bottom > 0 && main.top < window.innerHeight;
      var show = window.innerWidth <= 720 && root.classList.contains('is-revealed') && hasSeenOffer && isCurrentPaidDate() && productReady && hasVerifiedPrice(selectedTier) && checkoutButtons[0] && !checkoutButtons[0].disabled && !typing && !keyboard && !mainVisible && !checkoutBusy && !reviewPending && (!cartReview || cartReview.hidden);
      mobileCheckout.hidden = !show;
      root.classList.toggle('has-sticky', show);
    }
    function currentSituation() {
      var value = situation ? situation.value.replace(/\s+/g, ' ').trim().slice(0, 320) : '';
      return value || currentFocus().question;
    }
    function readingId() {
      return 'daily-v7-' + key.replace(/-/g, '') + '-' + hash([card[0], orientation, selectedFocus || 'general', currentSituation(), locale].join('|')).toString(36);
    }
    function saveState() {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify({
          version: 7,
          key: key,
          revealed: root.classList.contains('is-revealed'),
          selectedFocus: selectedFocus,
          situation: situation ? situation.value.slice(0, 320) : '',
          selectedTier: selectedTier,
          savedAt: Date.now()
        }));
      } catch (_) {}
    }
    function restoreState() {
      var saved;
      try { saved = JSON.parse(window.localStorage.getItem(storageKey) || window.localStorage.getItem('deckaura.dailyTarot.v6') || 'null'); } catch (_) { saved = null; }
      if (!saved || (saved.version !== 6 && saved.version !== 7)) return;
      if (/^(love|work|decision|wellbeing|general)$/.test(String(saved.selectedFocus || ''))) selectedFocus = saved.selectedFocus;
      if (/^(deeper|indepth)$/.test(String(saved.selectedTier || ''))) selectedTier = saved.selectedTier;
      if (situation && typeof saved.situation === 'string') {
        situation.value = saved.situation.slice(0, 320);
        var count = query(root, '[data-dt49-count]');
        if (count) count.textContent = String(situation.value.length);
      }
      updateContext(false, false);
      if (saved.revealed && saved.key === key) reveal(true);
      syncTierUi();
    }
    function enableReading(tier) {
      if (!offers || !root.classList.contains('is-revealed') || !isCurrentPaidDate()) return false;
      var api = window.DeckauraDeepReading;
      if (!api || typeof api.enable !== 'function') return false;
      selectedTier = /^(deeper|indepth)$/.test(tier) ? tier : selectedTier;
      var focus = currentFocus();
      var packageScope = PACKAGE_SCOPE[selectedTier];
      var supplied = Boolean(situation && situation.value.trim());
      var generation = contextGeneration;
      try {
        var readingOptions = {
          type: 'Daily Tarot',
          tool: 'Daily Tarot Card',
          canonicalPage: '/pages/daily-tarot-card',
          context: 'Local date: ' + key + '. Shared card: ' + card[0] + ' (' + orientation + '). Focus: ' + focus.label + '. Situation supplied: ' + (supplied ? 'yes' : 'no') + '. Reflective question: ' + currentSituation(),
          signals: [
            { label: 'Shared daily card', value: card[0] },
            { label: 'Orientation', value: orientation },
            { label: 'Focus', value: focus.label },
            { label: 'Reading horizon', value: packageScope.horizon }
          ],
          signalLimit: 4,
          cards: [{ name: card[0], orientation: orientation, position: "Today's shared card" }],
          cardLimit: 1,
          spread: "Today's shared card",
          scope: 'Interpret the supplied daily card, orientation, chosen focus and selected package horizon as reflective guidance. Do not invent events, private facts, dates or guarantees.',
          confidence: 'Date-seeded shared card and orientation; symbolic reflection rather than factual prediction.',
          readingId: readingId(),
          focus: focus.label,
          fixedFocus: focus.label,
          question: currentSituation(),
          curiosityQuestion: currentSituation(),
          requireContext: false,
          resultReady: true,
          defaultTier: selectedTier,
          presentationVariant: 'daily-enterprise-v7',
          lang: locale,
          analyticsTopic: 'daily-tarot',
          gate: false,
          teaser: false,
          title: t('reading_title'),
          text: t('reading_text'),
          button: t('checkout_button'),
          packageLabels: { deeper: t('package_deeper'), indepth: t('package_indepth') },
          checkoutGuard: isCurrentPaidDate,
          checkoutRecoveryHost: cartReview,
          onCartReviewReady: function (host) { cartReviewReady(generation, host); },
          checkoutProperties: function (checkoutPackage) {
            var tierName = checkoutPackage && checkoutPackage.tier || selectedTier;
            var spec = PACKAGE_SCOPE[tierName] || PACKAGE_SCOPE.deeper;
            return {
              '_Reading Category': DAILY_CATEGORY[selectedFocus],
              '_Answer': 'CONDITIONAL',
              '_Card Name': card[0],
              '_Daily date': key,
              '_Daily card': card[0],
              '_Daily card id': String(liveIndex + 1),
              '_Daily orientation': orientation,
              '_Daily focus': DAILY_INTENT_FOCUS[selectedFocus],
              '_Daily package': PACKAGE_NAMES[tierName] || PACKAGE_NAMES.deeper,
              '_Daily horizon': spec.horizon,
              '_Daily card count': String(spec.cards),
              '_Daily promise': spec.promise
            };
          },
          checkoutIntent: function (checkoutPackage) {
            var tierName = checkoutPackage && checkoutPackage.tier || selectedTier;
            var spec = PACKAGE_SCOPE[tierName] || PACKAGE_SCOPE.deeper;
            return {
              endpoint: 'https://reading.deckaura.com/reading-intent',
              body: {
                kind: 'daily_tarot',
                funnelVersion: 'daily-context-funnel-2026-09-v2',
                presentationVariant: 'daily-enterprise-v7',
                dateKey: key,
                cardName: card[0],
                cardId: liveIndex + 1,
                orientation: orientation,
                focus: DAILY_INTENT_FOCUS[selectedFocus] || 'general_direction',
                timeHorizon: spec.horizon,
                spreadSize: spec.cards,
                category: DAILY_CATEGORY[selectedFocus],
                answer: 'CONDITIONAL'
              }
            };
          },
          onTierChange: function (nextTier) {
            if (/^(deeper|indepth)$/.test(String(nextTier || ''))) {
              if (nextTier !== selectedTier) clearCartReview();
              selectedTier = nextTier;
              syncTierUi();
              saveState();
            }
          },
          onPricingStateChange: setPrices,
          onCheckoutNavigationConfirmed: function () { window.clearTimeout(checkoutTimer); checkoutFailed = false; setCheckoutBusy(false); },
          onPriceReady: function () { if (api.getPricingSnapshot) setPrices(api.getPricingSnapshot()); }
        };
        var requestedTier = selectedTier;
        if (readingReady && typeof api.update === 'function') api.update(readingOptions);
        else api.enable(readingOptions);
        selectedTier = requestedTier;
        if (api.setTier) api.setTier(selectedTier, 'daily_result');
        if (api.hide) api.hide();
        readingReady = true;
        configuredGeneration = generation;
        if (api.getPricingSnapshot) setPrices(api.getPricingSnapshot());
        else setCheckoutBusy(checkoutBusy);
        return true;
      } catch (error) {
        readingReady = false;
        configuredGeneration = -1;
        setCheckoutBusy(false);
        if (priceStatus) priceStatus.textContent = t('options_error');
        if (priceRetry) priceRetry.hidden = false;
        track('daily_reading_enable_failed_v7', { reason: error && error.message ? error.message : 'unknown' });
        return false;
      }
    }
    function waitForReading(attempt, generation) {
      generation = generation == null ? contextGeneration : generation;
      if (generation !== contextGeneration || !offers || !isCurrentPaidDate()) return;
      window.clearTimeout(readingTimer);
      readingTimer = 0;
      if (enableReading(selectedTier)) return;
      if (attempt < 80) readingTimer = window.setTimeout(function () { waitForReading(attempt + 1, generation); }, 100);
      else {
        if (priceStatus) priceStatus.textContent = t('options_error');
        if (priceRetry) priceRetry.hidden = false;
        setCheckoutBusy(false);
      }
    }
    function headline() {
      var line = String(displayCard.meaning || '').replace(/[.!?]+$/, '');
      return line ? line.charAt(0).toUpperCase() + line.slice(1) + '.' : t('headline_fallback');
    }
    function reveal(restoreMode) {
      if (root.classList.contains('is-revealed')) return;
      root.classList.add('is-revealed');
      var artSource = window.DeckauraTarotArt ? window.DeckauraTarotArt.url(card[0], 720) : (artMap[String(cardIndex)] || '');
      var source = appendWidth(artSource, window.innerWidth <= 720 ? 480 : 720);
      if (artSource && cardImage) {
        cardImage.srcset = appendWidth(artSource, 320) + ' 320w, ' + appendWidth(artSource, 480) + ' 480w, ' + appendWidth(artSource, 720) + ' 720w';
        cardImage.src = source;
      }
      if (cardImage) {
        cardImage.alt = t('card_alt', { card: displayCard.name, orientation: localizedOrientation });
        cardImage.style.transform = reversed ? 'rotate(180deg)' : '';
      }
      revealButtons.forEach(function (button) { button.setAttribute('aria-label', t('card_revealed', { card: displayCard.name, orientation: localizedOrientation })); });
      if (revealButton) revealButton.hidden = true;
      if (freeNote) freeNote.hidden = true;
      if (lead) lead.hidden = true;
      if (resultKicker) { resultKicker.hidden = false; resultKicker.textContent = localizedOrientation; }
      if (resultTitle) resultTitle.textContent = displayCard.name;
      if (result) result.hidden = false;
      updateReflection();
      if (offers) offers.hidden = isYesterday;
      if (archive) archive.hidden = !isYesterday;
      updateSticky();
      setPrices(lastPricingSnapshot);
      waitForReading(0);
      saveState();
      if (restoreMode !== true) {
        if (result) result.focus({ preventScroll: true });
        if (window.innerWidth <= 720) safeScroll(result, 'nearest');
        track('daily_card_revealed_v7', { card: card[0], orientation: orientation.toLowerCase(), date: key });
        track('daily_topic_reflection_v7', { focus: selectedFocus, orientation: orientation.toLowerCase(), situation_supplied: situation && situation.value.trim() ? 'yes' : 'no', source: 'automatic_reveal' });
      }
    }
    function updateReflection() {
      if (!root.classList.contains('is-revealed')) return;
      var focus = currentFocus();
      query(root, '[data-dt49-energy]').textContent = headline();
      query(root, '[data-dt49-notice]').textContent = selectedFocus === 'general' ? t(reversed ? 'notice_reversed' : 'notice_upright') : focus.notice;
      query(root, '[data-dt49-action]').textContent = selectedFocus === 'general' ? t('suit_' + (SUIT_ACTION[card[1]] ? card[1] : 'major')) : focus.action;
    }
    function updateContext(reconfigure, persist) {
      if (focusSelect) focusSelect.value = selectedFocus;
      updateReflection();
      if (persist !== false) saveState();
      if (reconfigure !== false && root.classList.contains('is-revealed')) waitForReading(0);
    }
    function checkout(tier, button) {
      updateCountdown();
      if (checkoutBusy || !isCurrentPaidDate() || !root.classList.contains('is-revealed')) return;
      var typedQuestion = situation ? situation.value.replace(/\s+/g, ' ').trim() : '';
      if (typedQuestion && Array.from(typedQuestion).length < 12) {
        var questionError = query(root, '[data-dt49-form-error]');
        if (questionError) questionError.textContent = t('question_short');
        situation.setAttribute('aria-invalid', 'true');
        situation.focus();
        return;
      }
      selectedTier = /^(deeper|indepth)$/.test(String(tier || '')) ? tier : 'deeper';
      clearCartReview();
      window.clearTimeout(contextTimer);
      syncTierUi();
      lastCheckoutButton = button || checkoutButtons.filter(function (candidate) { return candidate.getAttribute('data-dt49-checkout') === selectedTier; })[0] || null;
      checkoutFailed = false;
      if (checkoutSupport) checkoutSupport.hidden = true;
      if (priceRetry) priceRetry.hidden = true;
      saveState();
      var api = window.DeckauraDeepReading;
      if (!api || typeof api.checkoutNow !== 'function') {
        if (priceStatus) priceStatus.textContent = t('checkout_loading');
        waitForReading(0);
        return;
      }
      if (!enableReading(selectedTier)) return;
      try { if (api.setTier) api.setTier(selectedTier, 'user'); } catch (_) {}
      if (!hasVerifiedPrice(selectedTier) || api.isPriceReady && !api.isPriceReady()) {
        if (priceStatus) priceStatus.textContent = t('price_loading');
        if (priceRetry) priceRetry.hidden = false;
        setCheckoutBusy(false);
        return;
      }
      window.clearTimeout(checkoutTimer);
      setCheckoutBusy(true, button);
      var attempt = ++checkoutAttempt;
      var generation = contextGeneration;
      var started = false;
      var outcome = null;
      try {
        if (typeof api.checkoutNowAsync === 'function') {
          outcome = api.checkoutNowAsync();
          started = Boolean(outcome && typeof outcome.then === 'function');
        } else started = api.checkoutNow() === true;
      } catch (_) { started = false; }
      track('daily_checkout_clicked_v7', { tier: selectedTier, focus: selectedFocus || 'general', orientation: orientation.toLowerCase() });
      if (!started) {
        setCheckoutBusy(false);
        checkoutFailed = true;
        if (priceStatus) priceStatus.textContent = t('checkout_error');
        if (priceRetry) { priceRetry.textContent = t('checkout_retry'); priceRetry.hidden = false; }
        if (checkoutSupport) checkoutSupport.hidden = false;
        track('daily_checkout_failed_v7', { tier: selectedTier, reason: 'checkout_not_started' });
        return;
      }
      checkoutTimer = window.setTimeout(function () {
        if (!checkoutBusy) return;
        if (priceStatus) priceStatus.textContent = t('checkout_slow');
        if (priceRetry) priceRetry.hidden = true;
        if (checkoutSupport) checkoutSupport.hidden = false;
      }, 20000);
      if (outcome) outcome.then(function (result) {
        if (attempt !== checkoutAttempt || generation !== contextGeneration) return;
        if (result && result.ok) return;
        if (result && result.reason === 'checkout_return_recovered') {
          window.clearTimeout(checkoutTimer);
          checkoutFailed = false;
          setCheckoutBusy(false);
          setPrices(lastPricingSnapshot);
          return;
        }
        if (result && recoverableCartReason(result.reason)) {
          window.clearTimeout(checkoutTimer);
          checkoutFailed = false;
          setCheckoutBusy(false);
          setPrices(lastPricingSnapshot);
          return;
        }
        if (result && result.reason === 'checkout_timeout' && checkoutBusy) {
          if (priceStatus) priceStatus.textContent = t('checkout_slow');
          if (checkoutSupport) checkoutSupport.hidden = false;
          return;
        }
        window.clearTimeout(checkoutTimer);
        setCheckoutBusy(false);
        checkoutFailed = true;
        if (priceStatus) priceStatus.textContent = t('checkout_error');
        if (priceRetry) { priceRetry.textContent = t('checkout_retry'); priceRetry.hidden = false; }
        if (checkoutSupport) checkoutSupport.hidden = false;
      }).catch(function () {
        if (attempt !== checkoutAttempt || generation !== contextGeneration) return;
        window.clearTimeout(checkoutTimer);
        setCheckoutBusy(false);
        checkoutFailed = true;
        if (priceStatus) priceStatus.textContent = t('checkout_error');
        if (priceRetry) { priceRetry.textContent = t('checkout_retry'); priceRetry.hidden = false; }
        if (checkoutSupport) checkoutSupport.hidden = false;
      });
    }
    function updateCountdown() {
      var now = new Date();
      if (isYesterday) {
        if (countdown) countdown.textContent = t('yesterday_card');
        return;
      }
      if (!isCurrentPaidDate()) {
        if (!expired) {
          expired = true;
          checkoutAttempt += 1;
          window.clearTimeout(checkoutTimer);
          invalidateContext();
          try { if (window.DeckauraDeepReading && window.DeckauraDeepReading.disable) window.DeckauraDeepReading.disable(); } catch (_) {}
          readingReady = false;
          setPrices(lastPricingSnapshot);
          updateSticky();
        }
        if (countdown) countdown.textContent = t('refresh_today');
        return;
      }
      var next = new Date(now);
      next.setHours(24, 0, 0, 0);
      var seconds = Math.max(0, Math.floor((next.getTime() - now.getTime()) / 1000));
      if (countdown) countdown.textContent = pad(Math.floor(seconds / 3600)) + ':' + pad(Math.floor((seconds % 3600) / 60)) + ':' + pad(seconds % 60);
    }

    revealButtons.forEach(function (button) { button.addEventListener('click', function () { reveal(false); }); });
    if (focusSelect) {
      focusSelect.addEventListener('change', function () {
        if (checkoutBusy) return;
        var nextFocus = focusSelect.value;
        if (!/^(love|work|decision|wellbeing|general)$/.test(nextFocus)) return;
        invalidateContext();
        selectedFocus = nextFocus;
        updateContext();
        track('daily_focus_selected_v7', { focus: selectedFocus });
        track('daily_topic_reflection_v7', { focus: selectedFocus, orientation: orientation.toLowerCase(), situation_supplied: situation && situation.value.trim() ? 'yes' : 'no', source: 'focus_change' });
      });
    }
    if (situation) {
      situation.addEventListener('input', function () {
        if (checkoutBusy) return;
        invalidateContext();
        situation.removeAttribute('aria-invalid');
        var questionError = query(root, '[data-dt49-form-error]');
        if (questionError) questionError.textContent = '';
        updateSticky();
        query(root, '[data-dt49-count]').textContent = String(situation.value.length);
        saveState();
        window.clearTimeout(contextTimer);
        var generation = contextGeneration;
        contextTimer = window.setTimeout(function () {
          if (generation === contextGeneration && root.classList.contains('is-revealed')) waitForReading(0, generation);
        }, 450);
      });
    }
    tierButtons.forEach(function (button, index) {
      button.addEventListener('click', function () { chooseTier(button.getAttribute('data-dt49-tier')); });
      button.addEventListener('keydown', function (event) {
        var target = event.key === 'Home' ? 0 : event.key === 'End' ? tierButtons.length - 1 : event.key === 'ArrowRight' ? (index + 1) % tierButtons.length : event.key === 'ArrowLeft' ? (index + tierButtons.length - 1) % tierButtons.length : -1;
        if (target < 0) return;
        event.preventDefault();
        chooseTier(tierButtons[target].getAttribute('data-dt49-tier'), true);
      });
    });
    checkoutButtons.forEach(function (button) {
      button.addEventListener('click', function () { checkout(button.getAttribute('data-dt49-checkout') || 'deeper', button); });
    });
    if (stickyButton) stickyButton.addEventListener('click', function () { checkout(selectedTier, stickyButton); });
    if (window.IntersectionObserver && offers) {
      var offerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { if (entry.target === offers && entry.isIntersecting) hasSeenOffer = true; });
        updateSticky();
      });
      offerObserver.observe(offers);
      if (checkoutButtons[0]) offerObserver.observe(checkoutButtons[0]);
    }
    window.addEventListener('scroll', function () {
      if (!window.IntersectionObserver && offers && !offers.hidden) { var rect = offers.getBoundingClientRect(); if (rect.top < window.innerHeight && rect.bottom > 0) hasSeenOffer = true; }
      updateSticky();
    }, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
    document.addEventListener('focusin', updateSticky);
    document.addEventListener('focusout', function () { window.setTimeout(updateSticky, 0); });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', updateSticky, { passive: true });
    if (priceRetry) {
      priceRetry.addEventListener('click', function () {
        if (checkoutBusy || isYesterday) return;
        updateCountdown();
        if (expired) { saveState(); window.location.reload(); return; }
        var api = window.DeckauraDeepReading;
        if (checkoutFailed) {
          checkoutFailed = false;
          priceRetry.hidden = true;
          if (checkoutSupport) checkoutSupport.hidden = true;
          checkout(selectedTier, lastCheckoutButton);
          return;
        }
        if (priceStatus) priceStatus.textContent = t('price_retrying');
        priceRetry.hidden = true;
        setCheckoutBusy(false);
        if (!readingReady) {
          waitForReading(0);
          return;
        }
        try {
          if (api && api.retryPricing) api.retryPricing();
          else waitForReading(0);
        } catch (_) {
          if (priceStatus) priceStatus.textContent = t('options_error');
          priceRetry.hidden = false;
        }
      });
    }
    document.addEventListener('deckaura:funnel-event', function (event) {
      var detail = event && event.detail ? event.detail : {};
      var data = detail.data || {};
      if (detail.readingType !== 'Daily Tarot' || configuredGeneration !== contextGeneration || !isCurrentPaidDate() || (data.reading_id && data.reading_id !== readingId())) return;
      if (detail.name === 'checkout_prepare_start') {
        clearCartReview();
        setCheckoutBusy(true, lastCheckoutButton);
        dismissReturnHint();
        checkoutFailed = false;
        if (priceRetry) priceRetry.hidden = true;
        if (checkoutSupport) checkoutSupport.hidden = true;
        if (priceStatus) priceStatus.textContent = t('checkout_preparing');
      } else if (detail.name === 'checkout_cart_ready') {
        if (priceStatus) priceStatus.textContent = t('checkout_opening');
      } else if (detail.name === 'checkout_prepare_error') {
        window.clearTimeout(checkoutTimer);
        reviewReason = recoverableCartReason(data.reason) ? data.reason : '';
        reviewPending = Boolean(reviewReason);
        beforeReviewStatuses = reviewReason === 'reading_cart_conflict' ? sharedStatuses() : [];
        returnStatuses = null;
        setCheckoutBusy(false);
        checkoutFailed = !reviewReason;
        if (reviewReason) setPrices(lastPricingSnapshot);
        else {
          if (priceStatus) priceStatus.textContent = t('checkout_error');
          if (priceRetry) { priceRetry.textContent = t('checkout_retry'); priceRetry.hidden = false; }
          if (checkoutSupport) checkoutSupport.hidden = false;
        }
        track('daily_checkout_failed_v7', { tier: selectedTier, reason: 'checkout_prepare_error' });
      }
    });
    window.addEventListener('pageshow', function (event) {
      var statuses = event.persisted === true && configuredGeneration === contextGeneration && isCurrentPaidDate() && !checkoutBusy ? returnStatuses : null;
      updateCountdown();
      window.clearTimeout(checkoutTimer);
      checkoutAttempt += 1;
      checkoutFailed = false;
      clearCartReview();
      if (statuses) statuses.forEach(function (entry) { if (entry.node.isConnected && entry.node.textContent === entry.text) entry.node.textContent = ''; });
      setCheckoutBusy(false);
      if (readingReady && window.DeckauraDeepReading && window.DeckauraDeepReading.getPricingSnapshot) {
        setPrices(window.DeckauraDeepReading.getPricingSnapshot());
      }
    });
    if (cardImage) {
      cardImage.addEventListener('error', function () {
        cardImage.style.objectFit = 'cover';
        showToast(t('card_art_error'));
      });
    }
    updateContext(false, false);
    setPrices(lastPricingSnapshot);
    restoreState();
    updateCountdown();
    syncTierUi();
    window.setInterval(updateCountdown, 1000);
  }

  function start() {
    document.querySelectorAll('[data-dt49-root]').forEach(boot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
